import { render, staticRenderFns } from "./stockMovementsPage.vue?vue&type=template&id=be8cb882&"
import script from "./stockMovementsPage.vue?vue&type=script&lang=ts&"
export * from "./stockMovementsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports